import React, { useContext, useState, useEffect } from "react";
import "./styles/DatePicker.css";
import { CabinetContext } from "./CabinetContext";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

const ChevronL: string = require("../icons/chevron-left.svg").default;
const ChevronR: string = require("../icons/chevron-right.svg").default;
const ChevronD: string = require("../icons/chevron-down.svg").default;

function DatePicker() {
  const context = useContext(CabinetContext);
  const {
    sundaysWithThoughts,
    setWeek,
    week,
    view,
    setView,
    themes,
    fetchEvent,
    setThoughts,
  } = context;
  const [disabledRight, setDisabledRight] = useState(true);
  const [disabledLeft, setDisabledLeft] = useState(false);
  const [showTopics, setShowTopics] = useState<boolean>(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [displayTopic, setDisplayTopic] = useState<boolean>(false);
  const [day, setDay] = useState<number>(-1);
  const [month, setMonth] = useState<string>("");
  const [year, setYear] = useState<number>(-1);

  let months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // function to get the month name from a number
  const getMonthName = (month: number) => {
    return months[month - 1];
  };

  useEffect(() => {
    if (!sundaysWithThoughts) return;
    if (sundaysWithThoughts.length === 0) return;
    else {
      fetchEvent!(
        setDisabledLeft,
        setDisabledRight,
        searchParams,
        setDisplayTopic
      );
    }

    if (sundaysWithThoughts && week != null) {
      const [year, month, day] = sundaysWithThoughts[week]
        .toString()
        .split("-");
      setYear(parseInt(year));
      setMonth(getMonthName(parseInt(month)));
      setDay(parseInt(day));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sundaysWithThoughts]);

  const handleThemeClick = (theme: string) => {
    setView!(theme);
    if (themes) {
      const themeIndex = themes.findIndex((t) => t === theme);
      if (themeIndex > -1) {
        const params = createSearchParams({ theme: theme });
        navigate(process.env.PUBLIC_URL + `/?${params}`);
      }
    }
  };

  const handleWeekChange = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    direction: string
  ) => {
    if (e) e.preventDefault();
    if (!sundaysWithThoughts || !setWeek || week == null) return;

    const updateNavigation = (newWeek: number) => {
      const [year, month, day] = sundaysWithThoughts[newWeek]
        .toString()
        .split("-");
      setYear(parseInt(year));
      setMonth(getMonthName(parseInt(month)));
      setDay(parseInt(day));

      const params = createSearchParams({ date: `${month}-${day}-${year}` });
      navigate(process.env.PUBLIC_URL + `/?${params}`);
      setWeek(newWeek);
    };

    const updateDisabledStates = (left: boolean, right: boolean) => {
      setDisabledLeft(left);
      setDisabledRight(right);
    };

    if (direction === "next") {
      if (week === sundaysWithThoughts.length - 1) return;
      updateDisabledStates(false, week === sundaysWithThoughts.length - 2);
      updateNavigation(
        week === sundaysWithThoughts.length - 2
          ? sundaysWithThoughts.length - 1
          : week + 1
      );
    } else {
      if (week === 0) return;
      updateDisabledStates(week === 1, false);
      updateNavigation(week === 1 ? 0 : week - 1);
    }
  };

  const toggleView = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setDisplayTopic(true);
      setView!("topic");
      setShowTopics(true);
      handleThemeClick(themes![0]);
    } else {
      setDisplayTopic(false);
      setView!("calendar");
      setWeek!(sundaysWithThoughts!.length - 1);
      setDisabledRight(true);
      setShowTopics(false);
    }
  };

  return (
    <>
      <div className="switch-container">
        Calendar
        <label className="switch">
          <input
            className="toggle"
            type="checkbox"
            onChange={toggleView}
            checked={displayTopic}
          />
          <span className="slider"></span>
          <span className="card-side"></span>
        </label>
        Topic
      </div>
      {sundaysWithThoughts != null &&
        sundaysWithThoughts?.length > 0 &&
        week != null &&
        sundaysWithThoughts[week]?.length > 2 &&
        !displayTopic && (
          <div>
            <div className="week-selection-wrapper-mobile">
              <div className="week-selection-left">
                <button
                  disabled={disabledLeft}
                  className="week-selection-button"
                  onClick={(e) => {
                    handleWeekChange(e, "prev");
                  }}
                >
                  <img src={ChevronL} alt="left" />
                </button>
              </div>
              <div className="week-selection">
                <span className="intro">Week of </span>
                {" " + month + " " + day + ", " + year}
              </div>
              <div className="week-selection-right">
                <button
                  disabled={disabledRight}
                  className="week-selection-button"
                  onClick={(e) => handleWeekChange(e, "next")}
                >
                  <img src={ChevronR} alt="right" />
                </button>
              </div>
            </div>
            <div className="week-selection-wrapper">
              <div className="week-selection">
                <span className="intro">Week of </span>
                {month + " " + day + ", " + year}
              </div>
              <div className="week-selection-left">
                <button
                  disabled={disabledLeft}
                  className="week-selection-button"
                  onClick={(e) => {
                    handleWeekChange(e, "prev");
                  }}
                >
                  <img src={ChevronL} alt="left" />
                </button>
              </div>
              <div className="week-selection-right">
                <button
                  disabled={disabledRight}
                  className="week-selection-button"
                  onClick={(e) => handleWeekChange(e, "next")}
                >
                  <img src={ChevronR} alt="right" />
                </button>
              </div>
            </div>
          </div>
        )}
      <div>
        {displayTopic && (
          <div
            className={
              "view-selection-right" + (showTopics ? " open" : " closed")
            }
          >
            <div
              className="topic-header"
              onClick={() => setShowTopics(!showTopics)}
            >
              {" "}
              Topics <img src={ChevronD} alt="down" />
            </div>
            <div className="topic-dropdown">
              {themes?.map((theme) => (
                <div
                  className={"theme" + (view === theme ? " selected" : "")}
                  key={theme}
                  onClick={() => handleThemeClick(theme)}
                >
                  {theme}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default React.memo(DatePicker);
